import PadraoModel from 'src/core/model/PadraoModel.js'

export default class MobiautoMarcaModel extends PadraoModel {
  recurso = 'mobiauto/marcas';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Marcas Mobiauto';

  colunasGrid = [
  ];

  form = {
    id: null,
    name: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
